import React from "react";
import { StyledTag, StyledSupportCard, StyledSnippet, StyledArticleTitle, StyledLink } from "../style/support.style";

const SupCard = ({ card }) => {
	return (
		<StyledSupportCard id={card.id}>
			<StyledTag key={card.id + "tag"}>{card.tag}</StyledTag>
			<StyledArticleTitle key={card.id + "header"}>{card.header}</StyledArticleTitle>
			<StyledSnippet key={card.id + "snippet"}>{card.snippet}</StyledSnippet>
			{card.learnMoreHref ? (
				<StyledLink key={card.id + "link"} href={card.learnMoreHref}>
					Learn More
				</StyledLink>
			) : null}
		</StyledSupportCard>
	);
};
export default SupCard;
